import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "dialog-footer" }

import { contentTableConfig } from './config/content.config'
import { createData, updateData, deleteData } from '@/service/main/inspect/LiveStearmTransaction'
import PageContent from '@/components/PageContent.vue'
import { ref, reactive } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'livestreamTransaction',
  setup(__props) {

const pageContentRef = ref<InstanceType<typeof PageContent>>()

const dialogVisible = ref(false)
const dialogtitle = ref('')

const dialogClose = () => {
  dialogVisible.value = false
  Object.keys(form).forEach(key => {
    form[key] = '';
  });
  currid.value = ''
}

let currid = ref('')

let form = reactive({
  drawName: '',
  keywords: '',
  startTime: '',
  endTime: ''
})
const handleNewBtn = () => {
  console.log('点击新增')
  dialogtitle.value = '新增'
  dialogVisible.value = true
}
const handleEditBtn = (item: any) => {
  console.log('点击编辑')
  form.drawName = item.drawName
  form.keywords = item.keywords
  form.startTime = item.startTime
  form.endTime = item.endTime
  currid.value = item.id
  dialogtitle.value = '编辑'
  dialogVisible.value = true
}
const handleDelBtn = async (id: any) => {
  await deleteData('/main/drawConfig/delete/' + id).then((res) => {
    dialogClose()

    pageContentRef.value?.getPageData()

  })
}
const doSave = async () => {
  if (currid.value) {
    //新增
    console.log('编辑')
    await updateData('/main/drawConfig/update/' + currid.value, form).then((res) => {
      dialogClose()

      pageContentRef.value?.getPageData()
    })
  } else {

    console.log('新增')
    await createData('/main/drawConfig/add', form).then((res) => {
      dialogClose()

      pageContentRef.value?.getPageData()
    })
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(PageContent, {
      ref_key: "pageContentRef",
      ref: pageContentRef,
      contentTableConfig: _unref(contentTableConfig),
      pageName: "drawConfig",
      onNewBtnClick: handleNewBtn,
      onEditBtnClick: handleEditBtn,
      onDelBtnClick: handleDelBtn
    }, null, 8, ["contentTableConfig"]),
    _createVNode(_component_el_dialog, {
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((dialogVisible).value = $event)),
      title: dialogtitle.value,
      width: "30%",
      onClose: dialogClose
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_1, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: doSave
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 保存 ")
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_el_form, {
            model: _unref(form),
            "label-width": "120px"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "活动名称" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _unref(form).drawName,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).drawName) = $event)),
                    placeholder: "请输入活动名称"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "关键词" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _unref(form).keywords,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(form).keywords) = $event)),
                    placeholder: "请输入关键词 多个请用','隔开"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "开始时间" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_date_picker, {
                    modelValue: _unref(form).startTime,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(form).startTime) = $event)),
                    type: "datetime",
                    placeholder: "请选择开始时间",
                    format: "YYYY-MM-DD hh:mm:ss",
                    "value-format": "YYYY-MM-DD hh:mm:ss"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "结束时间" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_date_picker, {
                    modelValue: _unref(form).endTime,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(form).endTime) = $event)),
                    type: "datetime",
                    placeholder: "请选择结束时间",
                    format: "YYYY-MM-DD hh:mm:ss",
                    "value-format": "YYYY-MM-DD hh:mm:ss"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ], 64))
}
}

})